import { z } from 'zod';
/**
 * **모르는 분류값은 거부하지 말고 비운다.**
 *
 * 검증에는 성격이 다른 둘이 섞여 있다:
 *
 *   정체    어느 테이블에 넣을지 정한다 (`supportType`). 틀리면 저장할 곳이
 *           없으므로 **거부가 맞다.**
 *   꼬리표  단위·분류. 있으면 필터를 만들 수 있고 없으면 못 만들 뿐이다.
 *           조건 자체는 꼬리표 없이도 조건이다.
 *
 * 둘을 같이 취급한 것이 사고의 원인이었다. 「교육 40시간 이수」에서 단위
 * `hours` 를 몰랐다는 이유로 **조건 문장까지 버렸다.** 화면에 그 문장만
 * 띄우면 되는 일이었는데.
 *
 * 그래서 단위를 하나씩 추가하는 것은 대책이 아니다 — 분·초·회차·㎡ 는 끝이
 * 없고, 다음 것을 만날 때까지 또 잃는다. **모르면 비우고 나머지를 살린다**가
 * 유일하게 끝이 있는 규칙이다.
 *
 * 열거형을 넓히는 일은 그때부터 **기능 개선**이지 데이터 복구가 아니다.
 */
export function softEnum(values) {
    return z
        .unknown()
        .transform((v) => (typeof v === 'string' && values.includes(v)
        ? v
        : null));
}
/** 비울 수 없는 분류. 모르면 정해진 값으로 떨어진다 (`other` 같은 것). */
export function softEnumWith(values, fallback) {
    return z
        .unknown()
        .transform((v) => (typeof v === 'string' && values.includes(v)
        ? v
        : fallback));
}
//# sourceMappingURL=soft-enum.js.map